<contact-selector (selectedItemsChanged)="onSelectionChanged($event)" [previousSelection]="participants"></contact-selector>
<mat-dialog-actions  class="modal-footer flex flex-row justify-between items-center">
  <button mat-button class="orbitax-footer-button" (click)="onCancel()">Cancel</button>
  <button mat-button class="orbitax-footer-action-button" [disabled] = "disableDoneButton" (click)="onDone()">Done</button>
</mat-dialog-actions>
